import React from 'react'
// import moment from 'moment'
import Swal from 'sweetalert2'
import axios from 'axios'
import Constant from '../../../Constant.js'
// import Toggle from 'react-toggle'
// import Select from 'react-select'
// import GroupCheckbox from '../../../common/GroupCheckbox/GroupCheckbox.js'
import { Button } from '@material-ui/core'

class PagesMetaDataCreate extends React.Component {
  state = {
    page_link: '',

    meta_title_en: '',
    meta_title_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    h1_en: '',
    h1_ar: '',
    h2_en: '',
    h2_ar: '',

    is_saving: false,
  }

  async componentDidMount() {
    if (this.props?.match?.params?.type == 'edit') {
      await axios
        .get(Constant.getAPI() + '/admin/get-meta-data-for-pages/' + this.props.match.params.id, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({
            page_link: res.data.data.page_link,
            meta_title_en: res.data.data.meta_title_en,
            meta_title_ar: res.data.data.meta_title_ar,
            meta_keywords_en: res.data.data.meta_keywords_en,
            meta_keywords_ar: res.data.data.meta_keywords_ar,
            meta_desc_en: res.data.data.meta_desc_en,
            meta_desc_ar: res.data.data.meta_desc_ar,
            h1_en: res.data.data.h1_en,
            h1_ar: res.data.data.h1_ar,
            h2_en: res.data.data.h2_en,
            h2_ar: res.data.data.h2_ar,
          })
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSaveData = () => {
    this.setState({ is_saving: true })
    let data = {
      page_link: this.state.page_link,

      meta_title_en: this.state.meta_title_en,
      meta_title_ar: this.state.meta_title_ar,
      meta_keywords_en: this.state.meta_keywords_en,
      meta_keywords_ar: this.state.meta_keywords_ar,
      meta_desc_en: this.state.meta_desc_en,
      meta_desc_ar: this.state.meta_desc_ar,

      h1_en: this.state.h1_en,
      h1_ar: this.state.h1_ar,
      h2_en: this.state.h2_en,
      h2_ar: this.state.h2_ar,
    }

    if (this.props?.match?.params?.type == 'add') {
      axios
        .post(Constant.getAPI() + '/admin/create-meta-data-for-pages', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          Swal.fire({
            title: 'Created Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then(() => {
            window.history.back()
          })
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({ is_saving: false })
        })
    } else if (this.props?.match?.params?.type == 'edit' && this.props?.match?.params?.id) {
      data.id = this.props?.match?.params?.id

      axios
        .post(Constant.getAPI() + '/admin/update-meta-data-for-pages', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then(() => {
          Swal.fire({
            title: 'Updated Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          }).then(() => {
            window.history.back()
          })
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
        .finally(() => {
          this.setState({ is_saving: false })
        })
    }
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Website Page Link</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="page_link"
                              id="page_link"
                              placeholder="Link"
                              onChange={this.handleChange}
                              value={this.state.page_link}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                      ></div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Meta Title: English</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="meta_title_en"
                              id="meta_title_en"
                              placeholder="Enter Meta Title"
                              onChange={this.handleChange}
                              value={this.state.meta_title_en}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="meta_title_ar"
                              id="meta_title_ar"
                              placeholder="Enter Meta Title"
                              onChange={this.handleChange}
                              value={this.state.meta_title_ar}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Meta Keywords: English</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="meta_keywords_en"
                              id="meta_keywords_en"
                              placeholder="Enter Meta Keywords"
                              onChange={this.handleChange}
                              value={this.state.meta_keywords_en}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Meta Keywords: Arabic</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="meta_keywords_ar"
                              id="meta_keywords_ar"
                              placeholder="Enter Meta Keywords"
                              onChange={this.handleChange}
                              value={this.state.meta_keywords_ar}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Meta Description: English</label>
                          <div className="col-sm-9">
                            <textarea
                              type="text"
                              className="form-control"
                              placeholder="Please Enter Meta Description"
                              name="meta_desc_en"
                              id="meta_desc_en"
                              value={this.state.meta_desc_en}
                              onChange={this.handleChange}
                              rows="4"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                          <div className="col-sm-9">
                            <textarea
                              type="text"
                              className="form-control"
                              placeholder="Please Enter Meta Description"
                              name="meta_desc_ar"
                              id="meta_desc_ar"
                              value={this.state.meta_desc_ar}
                              onChange={this.handleChange}
                              rows="4"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">H1: English</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="h1_en"
                              id="h1_en"
                              placeholder="H1: English"
                              onChange={this.handleChange}
                              value={this.state.h1_en}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">H1: Arabic</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="h1_ar"
                              id="h1_ar"
                              placeholder="H1: Arabic"
                              onChange={this.handleChange}
                              value={this.state.h1_ar}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">H2: English</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="h2_en"
                              id="h2_en"
                              placeholder="H2: English"
                              onChange={this.handleChange}
                              value={this.state.h2_en}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">H2: Arabic</label>
                          <div className="col-sm-9">
                            <input
                              type="text"
                              className="form-control"
                              name="h2_ar"
                              id="h2_ar"
                              placeholder="H2: Arabic"
                              onChange={this.handleChange}
                              value={this.state.h2_ar}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card-footer">
                      <div className="row">
                        <div className="text-right col-6 offset-6">
                          <Button
                            startIcon={<i className="ti-save"></i>}
                            variant="contained"
                            color="primary"
                            onClick={this.onSaveData}
                            disabled={this.state.is_saving}
                          >
                            {this.state.is_saving ? 'Saving...' : 'Save'}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PagesMetaDataCreate
